'use client';

import { usePathname } from 'next/navigation';
import { useTranslations } from 'next-intl';
import { useState } from 'react';

import { UiKitButtonBase } from '@/fo/ui/kit/button/base';
import { UiKitDialogBase } from '@/fo/ui/kit/dialog/base';
import { utilEventCityModal } from '@/fo/util/event-city-modal';

import { setInformerCookie } from '../../utils/informerCookie';

import { styles } from './Dialog.styles';
type DialogProps = {
  city: string;
  open?: boolean;
};

export function Dialog({ city, open = true }: DialogProps) {
  const slots = styles();
  const t = useTranslations();
  const [dialogOpen, setDialogOpen] = useState(open);
  const pathname = usePathname();

  const isLanding =
    pathname.startsWith('/bioderma_atoderm') ||
    pathname.startsWith('/bioderma_hydrabio') ||
    pathname.startsWith('/bioderma_sebium') ||
    pathname.startsWith('/ie_intensive_hyaluronic') ||
    pathname.startsWith('/ie_ageproteom') ||
    pathname.startsWith('/ie_intensive_nad') ||
    pathname.startsWith('/eau-cellulaire') ||
    pathname.startsWith('/acneproject') ||
    pathname.startsWith('/bioderma_galchonok');
  const isWebviewChat = pathname === '/chat' || pathname.startsWith('/chat/');

  if (isLanding || isWebviewChat) return null;

  const onAgree = () => {
    setInformerCookie();
    setDialogOpen(false);
  };

  const onDisagree = () => {
    setInformerCookie();
    setDialogOpen(false);
    utilEventCityModal.open();
  };

  return (
    <UiKitDialogBase
      open={dialogOpen}
      modal={false}
      vertical="bottom"
      horizontal="left"
      dismissible={false}
      title={t('cityInformer.title', { city })}
      onOpenChange={(val) => !val && onAgree()}
    >
      <strong className={slots.heading()}>
        {t('cityInformer.title', { city })}
      </strong>
      <div className={slots.buttons()}>
        <UiKitButtonBase
          className={slots.button()}
          onClick={onAgree}
        >
          {t('cityInformer.yesCorrect')}
        </UiKitButtonBase>
        <UiKitButtonBase
          color="secondary"
          className={slots.button()}
          onClick={onDisagree}
        >
          {t('cityInformer.noOther')}
        </UiKitButtonBase>
      </div>
    </UiKitDialogBase>
  );
}
